export default __webpack_public_path__ + "static/BF-18c0c9b0ee9129f0acb53bd0c4aad707.jpg";